import SubcontractorRouteTransactionsList from "./SubcontractorRouteTransactionsList";

export default {
  name: "subcontractorRouteTransactions",
  list: SubcontractorRouteTransactionsList,
};
